import { render, staticRenderFns } from "./DeskTabs.vue?vue&type=template&id=55edf742&scoped=true&"
import script from "./DeskTabs.vue?vue&type=script&lang=js&"
export * from "./DeskTabs.vue?vue&type=script&lang=js&"
import style0 from "./DeskTabs.vue?vue&type=style&index=0&id=55edf742&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55edf742",
  null
  
)

export default component.exports